"use client"; // Границы ошибок должны быть клиентскими компонентами

import { useEffect } from "react";

import { AuthLayout } from "@/components/domain";
import { loggerError } from "@/constants";
import { clientLoggerError } from "@/lib/domain";

interface ErrorBoundaryProps {
  error: Error & { digest?: string };
  reset: () => void;
}

export default function ErrorBoundary(props: ErrorBoundaryProps) {
  const { error, reset } = props;

  useEffect(() => {
    // Логирование ошибки в сервис отчетов об ошибках
    clientLoggerError(`${loggerError.fetch}: - `, error);
  }, [error]);

  return (
    <AuthLayout>
      <div className="flex h-full flex-col items-center justify-center gap-y-6">
        <h2 className="text-2xl">Что-то пошло не так!</h2>
        <button
          className="btn-accent btn-size-large"
          onClick={
            // Попытка восстановить работу путем повторного рендеринга сегмента
            () => reset()
          }
          type="button"
        >
          Попробовать снова
        </button>
      </div>
    </AuthLayout>
  );
}
